import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { retry } from "../common/utils/commonFunction";

const CreatorDashboard = lazy(() =>
  retry(() => import("../pages/creator/Dashboard"))
);
const CompleteProfile = lazy(() =>
  retry(() => import("../pages/creator/CompleteProfile"))
);
const JobDetails = lazy(() => import("../pages/creator/JobDetails"));
const MyEarnings = lazy(() =>
  retry(() => import("../pages/creator/MyEarnings"))
);
const MySubscription = lazy(() =>
  retry(() => import("../pages/creator/MySubscription"))
);

const creatorRoutes = [
  {
    path: "/creator",
    element: <Navigate to="/creator/dashboard" replace />,
  },
  {
    path: "/creator/dashboard",
    element: <CreatorDashboard />,
  },
  {
    path: "/creator/complete-profile",
    element: <CompleteProfile />,
  },
  {
    path: "/creator/job/:jobId",
    element: <JobDetails />,
  },
  {
    path: "/creator/my-earnings",
    element: <MyEarnings />,
  },
  {
    path: "/creator/my-subscription",
    element: <MySubscription />,
  },
];

export default creatorRoutes;
